import React, {useEffect, useRef, useState} from "react";
import { useParams } from "react-router-dom";
import { PublicApiCall } from "../../apis/PublicApiCall";
import { ReactComponent as YUJA_LOGO } from "../../images/yujalogo.svg";
import {
    ACCOUNT_CARD_LOGOUT_TEXT,
    ACCOUNT_CARD_SUPPORT_TEXT,
    NAVBAR_ENGAGE, YUJA_SUPPORT_LINK
} from "../../utils/constants";
import { useLoading } from "../../utils/LoadingContext";
import useQuery from "../../utils/queryparam";
import styles from "./PPTLayout.module.css";
import navBarClasses from "../../components/YuJaNavbar.module.css";
import { usePPTWebView } from "../../hooks/usePPTWebView";
import { ReactComponent as LogOut } from "../../images/LogoutIcon.svg";
import { ReactComponent as Support } from "../../images/SupportIcon.svg";
import { roleValue2Display } from "../../utils/helpers";
import ProfileIcon from "../../components/ProfileIcon";
import {useConfig} from "../../hooks/useConfig";
import { Popover } from '@base-ui/react/popover';
import { Separator } from '@base-ui/react/separator';
import {Button} from "@base-ui/react/button";
import SupportModal from "../../components/modals/SupportModal";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";

export default function PPTLayout({children,}) {
    const { setLoading } = useLoading();
    const { appId } = useParams();
    const query = useQuery();
    const {checkExpired, parseToken, goLoginPage} = usePPTWebView();
    const config = useConfig();
    const {postPPTMessage} = PublicApiCall();
    const {getSupportCode} = InstitutionApiCalls();

    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("")
    const [role, setRole] = useState("");
    const [token, ] = useState(() => query.get("token"));

    const [pinCode, setPinCode] = useState("");
    const [menuItemList, setMenuItemList] = useState([]);
    const popoverRef = useRef(null);
    const [supportModalShown, setSupportModalShown] = useState(false);
    const [accessCode, setAccessCode] = useState("");


    useEffect(() => {
        if (checkExpired()) {
            //1. post websocket message
            postPPTMessage(appId, JSON.stringify({action: "clean"})).then(() => {
                //2. do redirect
                goLoginPage();
            });
            return;
        }

        const {firstName="", lastName="", role: roleVal="", email="", pinCode=""} = parseToken();

        let name = "";
        if (!!firstName) {
            name = firstName;
        }

        if (!!lastName) {
            name = !!name ? `${firstName} ${lastName}` : lastName;
        }
        setUserName(name);
        setEmail(email); 
        setRole(roleVal);
        setPinCode(!!pinCode ? pinCode : "");

        const copy = [];
        copy.push({
            icon: Support,
            label: ACCOUNT_CARD_SUPPORT_TEXT,
            onClick: () => {
                // window.open(YUJA_SUPPORT_LINK);
                setSupportModalShown(true);
                closeProfileMenu();
            }
        });
        copy.push({
            icon: LogOut,
            label: ACCOUNT_CARD_LOGOUT_TEXT,
            onClick: () => logout()
        });

        setMenuItemList(copy);
    }, []);

    useEffect(() => {
        getSupportCode().then(code => {
            setAccessCode(code);
        });
    }, []);


    const logout = () => {
        //1. post websocket message
        setLoading(true);
        postPPTMessage(appId, JSON.stringify({action: "clean"})).then(() => {
            //2. do redirect
            window.open(`${config.ppt_mgmt_portal}/PPT/${appId}/dispatch`, "_self");
        }).finally(() => {
            setLoading(false);
        });
    }

    const closeProfileMenu = () => {
        if (popoverRef.current) {
            popoverRef.current.close();
        }
    }

    return (
        <div className={styles.container}>
            <SupportModal
                open={supportModalShown}
                setOpen={setSupportModalShown}
                accessCode={accessCode}
            />
            <div className={styles.topBarContainer}>
                <div className={styles.logoContainer}>
                    <YUJA_LOGO width={24} height={24}/>
                </div>
                <span className={styles.title} >{NAVBAR_ENGAGE}</span>
                <div style={{flex: 1}}/>

                <Popover.Root modal={"trap-focus"} actionsRef={popoverRef}  style={{display: "flex", alignItems: "center"}}>
                    <Popover.Trigger id={"profile-btn"} aria-label={"my account"} className={navBarClasses.profileBtn}>
                        <ProfileIcon
                            size={33}
                            initialLetter={userName[0] ? userName[0] : "G"}
                        />
                    </Popover.Trigger>
                    <Popover.Portal >
                        <Popover.Positioner sideOffset={5} style={{zIndex: 1000}}  align={"end"}>
                            <Popover.Popup >
                                <div className={navBarClasses.profileMenuContainer}>
                                    <div style={{width: 180, display: "flex", flexDirection: "column", alignItems: "center"}}>
                                        <ProfileIcon
                                            size={45}
                                            initialLetter={userName[0] ? userName[0] : "G"}
                                            style={{margin: 10}}
                                        />
                                        <div
                                            title={userName}
                                            style={{
                                                textAlign: "center", fontWeight: 700, maxWidth: "175px",
                                                fontSize: 20, lineHeight: 1.4, overflow: "hidden", whiteSpace: "nowrap",
                                                textOverflow: "ellipsis", paddingLeft: "10px", paddingRight: "10px"
                                            }}
                                        >{userName} </div>
                                        <div style={{color: "#6F6F6F", fontSize: 14, lineHeight: 1.6,}}>
                                            {roleValue2Display(role)}
                                        </div>
                                        <div
                                            title={email}
                                            style={{
                                                overflow: "hidden", maxWidth: "175px",
                                                textOverflow: "ellipsis", whiteSpace: "nowrap",
                                                fontSize: "14px", lineHeight: 1.6, paddingLeft: "10px", paddingRight: "10px"
                                            }}
                                        > {email} </div>
                                        {!!pinCode &&
                                            <div style={{color: "#6F6F6F", fontSize: "14px", lineHeight: 1.6,}}>
                                                {`PIN: ${pinCode}`}
                                            </div>
                                        }
                                    </div>
                                    <Separator orientation="horizontal" className={navBarClasses.separator}/>
                                    <ul
                                        id={"profile-menu"}
                                        aria-label={"user-profile"}
                                        role={"menu"}
                                        className={navBarClasses.profileMenu}
                                    >
                                        {menuItemList.map((item, index) => {
                                            const {icon, label, onClick} = item;
                                            const Icon = icon;
                                            return (
                                                <li key={index}>
                                                    <Button
                                                        className={navBarClasses.profileMenuItem}
                                                        autoFocus={index === 0}
                                                        aria-label={label}
                                                        onClick={() => onClick()}
                                                    >
                                                        <Icon style={{width: 24, height: 24}} focusable={false}
                                                              role={"presentation"}/>
                                                        <span>{label}</span>
                                                    </Button>

                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>

                            </Popover.Popup>
                        </Popover.Positioner>
                    </Popover.Portal>
                </Popover.Root>
            </div>

            <div style={{flex: 1, width: "100%", display: "flex", position: "relative", overflow: "auto"}}>

                {!!token &&
                    <main className={styles.majorContainer}>{children}</main>
                }
                <div id="sr-feedback" aria-live="polite" aria-atomic="true"></div>
            </div>
        </div>
    );
}